import { dialogs, i18next } from '@yola/ws-sdk';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';

const showCopyToClipboardErrorDialog = () => {
  dialogs.operations.show(dialogTypes.ALERT_DIALOG, {
    glyph: 'alert-circle',
    captions: {
      title: i18next.t('Oops!'),
      description: i18next.t(
        'Something went wrong while copying to the clipboard. Please try again.'
      ),
      dismiss: i18next.t('Got it'),
    },
    onDismiss: () => dialogs.operations.hide(),
  });
};

export default showCopyToClipboardErrorDialog;
